/**
 * Sample narrative featured on the home page. The hero phone embeds it, and
 * the home form's auto-reply links to it, so visitors get the same sample
 * they saw on the page.
 */
export const HOME_SAMPLE_REPORT_ID = "loopwire_northfield_2025_yir_p4n7k2";

/**
 * The landing comparison's "after" is a static screenshot of the sample
 * narrative's "Hours saved, quarter by quarter" page, which mirrors the
 * quarterly table on the "before" PDF stack's top page, so the two sides
 * read as the same content.
 *
 * To regenerate it (e.g. after the narrative changes), open
 * `/?report=<HOME_SAMPLE_REPORT_ID>&p=5` at a 430×880 viewport with a 2×
 * device scale, wait for the page's animations to finish, hide the
 * "continue" hint (`[data-continue-indicator]`), and save a JPEG to
 * `public/landing/sample-hours-by-quarter.jpg`.
 */
export const COMPARISON_SCREENSHOT = "/landing/sample-hours-by-quarter.jpg";

/** Intrinsic size of the comparison's PDF stack (scaled with ScaleToFit). */
export const PDF_STACK_SIZE = { width: 600, height: 740 };

/**
 * Intrinsic size of the comparison's phone screen: the screenshot's size
 * in CSS pixels. The whole phone is scaled to the frame.
 */
export const PHONE_SCREEN = { width: 430, height: 880 };
export const PHONE_BEZEL = 14;
